import React from 'react';
import PropTypes from 'prop-types';
import { SuiContainer } from '@splashthat/sui';

const CharacterCountdown = ({ labelLength, maxLength }) => {
    const remainingCharacters = Math.max(maxLength - labelLength, 0);

    return (
        <SuiContainer className={'question-label__char'}>
            <p>{`${remainingCharacters} character${remainingCharacters === 1 ? '' : 's'} left`}</p>
        </SuiContainer>
    );
};

CharacterCountdown.propTypes = {
    labelLength: PropTypes.number.isRequired,
    maxLength: PropTypes.number.isRequired,
};

export default CharacterCountdown;
